export default {
  title: 'Настройки виджета',
  minValue: 'Минимальный порог',
  maxValue: 'Максимальный порог',
  submit: 'Применить',
  cancel: 'Отменить',
}
